// Single source of truth for cookie-consent-gated tracking.
// Third-party analytics (Swetrix/GA) are strictly opt-in; internal first-party
// visit pings respect an explicit "Decline".

let _analyticsEnabled = false; // Swetrix/GA active (config enabled + consent satisfied)
let _consentRequired = false;  // admin has the cookie banner enabled

export const CONSENT_KEY = "sig_cookie_consent";
export const CONSENT_EVENT = "sig-consent-changed";

export const getConsent = () => {
  try { return localStorage.getItem(CONSENT_KEY); } catch { return null; }
};

export const setAnalyticsEnabled = (v) => { _analyticsEnabled = !!v; };
export const isAnalyticsEnabled = () => _analyticsEnabled;

export const setConsentRequired = (v) => { _consentRequired = !!v; };

// Internal (first-party) visit tracking: blocked on explicit decline, and on
// undecided when a consent banner is required. Allowed otherwise.
export const visitTrackingAllowed = () => {
  if (getConsent() === "declined") return false;
  return !_consentRequired || getConsent() === "accepted";
};

export const notifyConsentChanged = () => {
  try { window.dispatchEvent(new Event(CONSENT_EVENT)); } catch { /* noop */ }
};

// Lets a "Cookie settings" link anywhere reopen the consent banner.
export const OPEN_COOKIE_EVENT = "sig-open-cookie";
export const openCookieSettings = () => {
  try { window.dispatchEvent(new Event(OPEN_COOKIE_EVENT)); } catch { /* noop */ }
};
